import { tv } from "../../../../node_modules/.pnpm/tailwind-variants@3.2.2_tailwind-merge@3.3.0_tailwindcss@4.1.8/node_modules/tailwind-variants/dist/index.js";
const radioGroupItemVariants = tv({
  base: `
    peer border border-(--gray-border-2) dark:border-(--gray-border-3) hover:border-(--gray-border-3) dark:hover:border-(--gray-primary-1)
    shrink-0 ring-offset-background transition-all outline-none aspect-square shadow-xs rounded-full content-center
    data-[state=checked]:bg-(--primary-2) data-[state=checked]:border-(--primary-2) data-[state=checked]:text-(--white)
    disabled:cursor-not-allowed disabled:border-(--gray-border-1) disabled:bg-(--gray-tag-1) disabled:text-(--gray-border-3)
    disabled:data-[state=checked]:border-(--gray-border-1) disabled:data-[state=checked]:bg-(--gray-tag-1)
    disabled:data-[state=checked]:text-(--gray-border-3) disabled:[&_svg]:fill-(--gray-border-3)
    aria-invalid:ring-destructive/20 dark:aria-invalid:ring-destructive/40 aria-invalid:border-(--red-9-alpha)
    aria-invalid:data-[state=checked]:bg-(--red-9-alpha) aria-invalid:data-[state=checked]:border-(--red-9-alpha)
    focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2
    focus-visible:border-ring focus-visible:border-(--gray-primary-1)
  `,
  variants: {
    size: {
      sm: "size-3.5",
      default: "size-4",
      lg: "size-5"
    }
  },
  defaultVariants: {
    size: "default"
  }
}), radioWrapperGroupVariants = tv({
  variants: {
    orientation: {
      horizontal: "flex gap-6",
      vertical: ""
    }
  },
  defaultVariants: {
    orientation: "vertical"
  }
});
export {
  radioGroupItemVariants,
  radioWrapperGroupVariants
};
//# sourceMappingURL=index.js.map
